import Referral from './Referral'

export default Referral
